import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  NavigateNext,
  RemoveRedEyeOutlined,
  SearchOutlined,
} from "@mui/icons-material";
import { NavigateFunction, useNavigate } from "react-router-dom";
import { alertError, alertSuccess } from "../../../../components/alert/swal";
import { advisorFileApi } from "../../../../api/advisor-file/advisor-file.api";
import SwitchCustom from "../../../../components/switch/SwitchCustom";
import { dateTimeToView } from "../../../../utils/date.utils";
import {
  setLoading,
  unsetLoading,
} from "../../../../store/loading/loading.slice";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import InputTextField from "../../../../components/input/inputTextField";
import { debouncedApiCall } from "../../../../utils/app.utils";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import TableCustom from "../../../../components/table/tableCustom";
import { getFileExtension } from "../../../../utils/fileTypeDownload";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";

type Props = {};

const ListDocuments: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getDocumentFile = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
    };

    if (search) query = { ...query, search: search };

    const res = await advisorFileApi.getAllAdvisorFile(query);
    const data = res.data;
    if (data.status < 300) {
      setData(data.data.items);
      setTotalItems(res.data?.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  // const handleDownloadFile = async (id_file: number) => {
  //   await advisorFileApi
  //     .downloadFile(id_file)
  //     .then((res) => {
  //       if (res.status < 300) {
  //         alertSuccess("สำเร็จ", "ดาวน์โหลดไฟล์เรียบร้อย", "ตกลง");
  //       }
  //     })
  //     .catch((error) => alertError("ดาวน์โหลด ไม่สำเร็จ"))
  //     .finally(() => {});
  // };

  const handleDownloadFile = async (id: number, name_file: string) => {
    dispatch(setLoading());
    await advisorFileApi
      .downloadFile(id)
      .then((res) => {
        if (res.status < 300) {
          const response = res.data;

          // Get the content type from the server's response headers
          const contentType = res.headers["content-type"];

          // Create a Blob with the content type from the response
          const blob = new Blob([response], { type: contentType });

          // Extract file extension based on content type
          const fileExtension = getFileExtension(contentType || "");

          // Generate a filename with the correct extension (you can also modify this to use a custom name)
          const fileName = `${name_file}.${fileExtension}`;

          // Save the file
          saveAs(blob, fileName);
        }
      })
      .catch((error) => console.log(error))
      .finally(() => dispatch(unsetLoading()));
  };

  const headCells = [
    {
      id: "advisor_file",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: t("ชื่อเอกสาร"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 15,
      label: "action",
    },
  ];

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const { id_advisor_file, advisor_file_name, advisor_file_path, advisor_file } = objData;

    const objRenderData = {
      key: id_advisor_file,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: advisor_file,
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <FileDownloadOutlinedIcon
                onClick={() => {
                  handleDownloadFile(
                    id_advisor_file,
                    advisor_file_name +
                      advisor_file_name +
                      "-" +
                      new Date().getTime()
                  );
                }}
                style={{
                  cursor: "pointer",
                  marginRight: "24px",
                }}
              />

              <a
                href={`${process.env.REACT_APP_FILE_BASE_API}/${advisor_file_path}`}
                target="_blank"
                rel="noreferrer"
                style={{
                  cursor: "pointer",
                }}
              >
                <RemoveRedEyeOutlined
                  onClick={() => {}}
                  style={{
                    cursor: "pointer",
                  }}
                />
              </a>
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    dispatch(setLoading());
    setTimeout(() => {
      dispatch(unsetLoading());
    }, 500);
  }, []);

  useEffect(() => {
    getDocumentFile();
  }, [page, pageLimit, sortBy, sortType, search]);

  return (
    <div>
      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 md:col-span-4 lg:col-span-3 sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อประเภท")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={600}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default ListDocuments;
